import React from 'react';

/** @internal */
export var insuranceIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.6451 19.613H21.6774V12.3872H20.6451V19.613Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.03225 20.6452H30.9677V11.3549H1.03225V20.6452ZM11.3548 30.9676H20.6451V21.6772H11.3548V30.9676ZM11.3548 10.3225H20.6451V1.03214H11.3548V10.3225ZM30.9677 10.3226H21.6774V1.03226C21.6774 0.464516 21.2129 0 20.6452 0H11.3548C10.7871 0 10.3226 0.464516 10.3226 1.03226V10.3226H1.03226C0.464516 10.3226 0 10.7871 0 11.3548V20.6452C0 21.2129 0.464516 21.6774 1.03226 21.6774H10.3226V30.9677C10.3226 31.5355 10.7871 32 11.3548 32H20.6452C21.2129 32 21.6774 31.5355 21.6774 30.9677V21.6774H30.9677C31.5355 21.6774 32 21.2129 32 20.6452V11.3548C32 10.7871 31.5355 10.3226 30.9677 10.3226Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3225 19.613H11.3548V12.3872H10.3225V19.613Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.4193 14.4517H14.4516V13.4194H13.4193V14.4517Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4839 14.4517H16.5161V13.4194H15.4839V14.4517Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5485 14.4517H18.5807V13.4194H17.5485V14.4517Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.4193 16.5161H14.4516V15.4839H13.4193V16.5161Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4839 16.5161H16.5161V15.4839H15.4839V16.5161Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5485 16.5161H18.5807V15.4839H17.5485V16.5161Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.4193 18.5806H14.4516V17.5483H13.4193V18.5806Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4839 18.5806H16.5161V17.5483H15.4839V18.5806Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5485 18.5806H18.5807V17.5483H17.5485V18.5806Z"
}));